import { CSSProperties } from 'react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { GlobalStyles } from '@mui/material';
import { CkeditorStyled } from './Ckeditor.styled';

interface CKEditorComponentProps {
  content: string;
  styleSet?: CSSProperties;
  onChange: (value: string) => void;
}

const CKEditorComponent = (props: CKEditorComponentProps): JSX.Element => {
  const { content, styleSet, onChange } = props;

  const inputHandler = (_event: any, editorInstance: any) => {
    const newContent = editorInstance.getData();
    onChange(newContent); // Notify the parent component of changes
  };

  return (
    <CkeditorStyled>
      <GlobalStyles
        styles={{
          '.ck.ck-balloon-panel': {
            zIndex: '9999 !important',
          },
        }}
      />
      <div style={styleSet}>
        <CKEditor
          editor={ClassicEditor as any}
          data={content}
          watchdogConfig={{ crashNumberLimit: 10 }}
          config={{
            removePlugins: ['EasyImage', 'ImageUpload', 'MediaEmbed', 'Table'],
          }}
          onChange={inputHandler}
        />
      </div>
    </CkeditorStyled>
  );
};

CKEditorComponent.defaultProps = {
  styleSet: undefined,
};

export default CKEditorComponent;
